// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background: #f4f4f4;
}

.home-container {
	text-align: center;
}

.fade-in {
	opacity: 0;
	animation: fadeIn 2s ease-in forwards;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,qCAAqC;AACtC;;AAEA;CACC;EACC,UAAU;EACV,4BAA4B;CAC7B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD","sourcesContent":[".home {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100vh;\n\tbackground: #f4f4f4;\n}\n\n.home-container {\n\ttext-align: center;\n}\n\n.fade-in {\n\topacity: 0;\n\tanimation: fadeIn 2s ease-in forwards;\n}\n\n@keyframes fadeIn {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(-20px);\n\t}\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
